<div *ngIf="useDocComments && showQuery && !querying && !docIsSigned" class="consulta-trigger">
  <button mat-raised-button class="consulta-trigger__btn" color="primary"
          (click)="startQueryFlow()" [disabled]="loading">
    <div class="mat-button-wrapper" fxLayout="row" fxLayoutAlign="center center">
      <mat-icon *ngIf="loading" class="fa-xs fa-spin" fontSet="fa" fontIcon="fa-spinner-third"></mat-icon>
      <ng-container *ngIf="!loading">
        <mat-icon class="fa-lg" fontSet="fa"
                  [fontIcon]="hasQuery ? 'fa-comments' : 'fa-comment-medical'"></mat-icon>
        <span>{{ hasQuery ? ('common.viewQuery' | transloco) : ('common.makeQuery' | transloco) }}</span>
      </ng-container>
      <span *ngIf="loading">{{ 'common.loading' | transloco }}</span>
    </div>
  </button>
</div>

<div class="consulta-panel"
     *ngIf="useDocComments && showQuery && querying"
     [class.consulta-panel--minimizado]="isMinimized">

  <mat-progress-bar mode="indeterminate"
                    [style.display]="loading ? 'block' : 'none'"
                    class="consulta-panel__progress">
  </mat-progress-bar>

  <mat-divider></mat-divider>
  <mat-progress-bar mode="indeterminate" [style.display]="loading ? 'block' : 'none'"></mat-progress-bar>

  <div *ngIf="isMinimized" class="minimized-info-bar" (click)="toggleMinimize()" (keyup.enter)="toggleMinimize()" tabindex="0">
    <mat-icon fontSet="fa" fontIcon="fa-comments" class="info-icon"></mat-icon>
    <span>{{ 'common.queryPanelActive' | transloco }}</span>
  </div>

  <div class="consulta-cuerpo" *ngIf="!isMinimized">

    <div class="consulta-col consulta-col--info">
      <div class="consulta-info">
        <div class="consulta-info__header">
          <button mat-icon-button (click)="closeQuery()" [title]="'common.closeBtn' | transloco"
                  class="consulta-info__cerrar">
            <mat-icon fontSet="fa" fontIcon="fa-times"></mat-icon>
          </button>
          <h2 class="consulta-info__titulo">{{ 'common.queries' | transloco }}</h2>

          <button mat-icon-button
                  class="consulta-info__minimizar-sm"
                  (click)="toggleMinimize()"
                  [title]="isMinimized ? ('common.expand' | transloco) : ('common.minimize' | transloco)">
            <mat-icon fontSet="fa"
                      [fontIcon]="isMinimized ? 'fa-chevron-up' : 'fa-chevron-down'">
            </mat-icon>
          </button>
        </div>

        <ng-container *ngIf="hasQuery && queryHistory[0]">
          <span class="consulta-info__badge">
            {{ getFriendlyLabel(queryHistory[0].messageType) }}
          </span>
        </ng-container>
        <span *ngIf="!hasQuery && motives.length > 0" class="consulta-info__placeholder">
          {{ 'common.selectQueryReason' | transloco }}
        </span>

        <button mat-stroked-button color="warn"
                class="consulta-info__btn-finalizar"
                *ngIf="hasQuery && !doc.threadClosed && !hideCloseQuery"
                [disabled]="loading"
                (click)="closeQueryThread()">
          {{ 'common.finishQuery' | transloco }}
        </button>

        <div class="consulta-info__cerrada" *ngIf="doc?.hasMessage && doc?.threadClosed">
          <mat-icon fontSet="fa" fontIcon="fa-check-circle"></mat-icon>
          <span>{{ 'common.queryClosed' | transloco }}</span>
        </div>
      </div>
    </div>

    <div class="consulta-col consulta-col--chat">

      <ng-container *ngIf="!hasQuery">
        <div class="consulta-nueva">
          <img src="assets/img/user-avatar.png" class="consulta-nueva__avatar" alt="">
          <div class="consulta-nueva__campos">
            <!-- El motivo es opcional: solo se pide si la empresa tiene motivos configurados -->
            <mat-form-field appearance="outline" style="width:100%" *ngIf="motives.length > 0">
              <mat-label>{{ 'common.queryReason' | transloco }}</mat-label>
              <mat-select [(ngModel)]="queryForm.messageType" required>
                <mat-option *ngFor="let m of motives" [value]="m">
                  {{ m }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" style="width:100%">
              <mat-label>{{ 'common.queryDescription' | transloco }}</mat-label>
              <textarea matInput rows="3" [(ngModel)]="queryForm.message"
                        style="resize:none"
                        [placeholder]="'common.writeHere' | transloco"></textarea>
            </mat-form-field>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="hasQuery">
        <div #scrollContainer class="consulta-mensajes">
          <div *ngFor="let msg of queryHistory"
               class="consulta-msg"
               [class.consulta-msg--propio]="msg.userId === currentUser.id">

            <div class="consulta-msg__avatar">
              <ngx-avatar [name]="msg.userName" [src]="'avatar-preview'"
                          size="30" [round]="true"></ngx-avatar>
            </div>

            <div class="consulta-msg__burbuja"
                 [class.consulta-msg__burbuja--propia]="msg.userId === currentUser.id"
                 [class.consulta-msg__burbuja--otra]="msg.userId !== currentUser.id">
              <span class="consulta-msg__nombre">{{ msg.userName }}</span>
              <span *ngIf="msg.isDeleted" class="consulta-msg__eliminado">
                {{ 'fileDocuments.fileDocumentQuery.messageDeletedLbl' | transloco }}
              </span>
              <span *ngIf="!msg.isDeleted">{{ msg.message }}</span>
              <div class="consulta-msg__meta">
                <a href="javascript:void(0)"
                   *ngIf="msg.userId === currentUser.id && !msg.isDeleted && !doc.threadClosed"
                   class="consulta-msg__eliminar"
                   (click)="deleteMessage(msg.id)">{{ 'common.delete' | transloco }}</a>
                <span *ngIf="msg.userId === currentUser.id" class="consulta-msg__sep">|</span>
                <span class="consulta-msg__fecha">
                  {{ msg.creationDate | date: 'dd MMM yyyy HH:mm' }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="consulta-respuesta" *ngIf="!doc.threadClosed">
          <ngx-avatar [name]="currentUser.firstName + ' ' + currentUser.lastName"
                      [src]="'avatar-preview'" size="30" [round]="true"
                      class="consulta-respuesta__avatar"></ngx-avatar>
          <mat-form-field appearance="outline" class="consulta-respuesta__campo">
            <mat-label>{{ 'common.queryReply' | transloco }}</mat-label>
            <textarea matInput rows="1" [(ngModel)]="replyText"
                      (input)="validateInput($event)"
                      (keyup.enter)="sendReply()"
                      style="resize:none"
                      [placeholder]="'common.writeHere' | transloco"></textarea>
          </mat-form-field>
          <button mat-mini-fab
                  class="consulta-respuesta__enviar-mobile"
                  color="accent"
                  [disabled]="loading || !replyText"
                  (click)="sendReply()">
            <mat-icon fontSet="fa" fontIcon="fa-long-arrow-alt-right"></mat-icon>
          </button>
        </div>

      </ng-container>
    </div>

    <div class="consulta-col consulta-col--acciones">
      <button mat-icon-button
              class="consulta-acciones__minimizar"
              (click)="toggleMinimize()"
              [title]="isMinimized ? ('fileDocuments.fileDocumentQuery.expandQueryTooltip' | transloco) : ('fileDocuments.fileDocumentQuery.minimizeQueryTooltip' | transloco)">
        <mat-icon fontSet="fa"
                  [fontIcon]="isMinimized ? 'fa-chevron-up' : 'fa-chevron-down'">
        </mat-icon>
      </button>

      <button mat-raised-button
              *ngIf="!doc.threadClosed"
              class="consulta-acciones__enviar"
              color="accent"
              [disabled]="loading || (!hasQuery ? !canSubmitNewQuery : !replyText)"
              (click)="hasQuery ? sendReply() : submitNewQuery()">
        <mat-icon fontSet="fa" fontIcon="fa-long-arrow-alt-right"></mat-icon>
        <span>{{ 'common.send' | transloco }}</span>
      </button>
    </div>

  </div>
</div>
